module.exports = __webpack_public_path__ + "media/icon_transaction/cat-674b29ea.png";